import { Component, DOCUMENT, inject, Renderer2 } from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {AppService} from './services/app.service';
import { DarkModeService } from './services/dark-mode.service';

@Component({
    selector: 'osce-root',
    imports: [
        RouterOutlet,
    ],
    template: `
        <router-outlet></router-outlet>
    `,
    styles: [`

    `]
})
export class App {
    private _appService = inject(AppService);
    private _darkMode = inject(DarkModeService);
    private _renderer: Renderer2 = inject(Renderer2);
    private _document = inject(DOCUMENT);

    constructor() {
        this._darkMode.darkMode$
            .subscribe((darkMode) => {
                if (darkMode) {
                    this._renderer.addClass(this._document.body, 'dark-theme');
                    this._renderer.removeClass(this._document.body, 'light-theme');
                } else {
                    this._renderer.removeClass(this._document.body, 'dark-theme');
                    this._renderer.addClass(this._document.body, 'light-theme');
                }
            })

    }
}
